import { render, staticRenderFns } from "./cases_search.vue?vue&type=template&id=6b1e1678&scoped=true&"
import script from "./cases_search.vue?vue&type=script&lang=js&"
export * from "./cases_search.vue?vue&type=script&lang=js&"
import style0 from "./cases_search.vue?vue&type=style&index=0&id=6b1e1678&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1e1678",
  null
  
)

export default component.exports